import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Services from '@/views/Services.vue'
import Faq from '@/views/faq.vue'
import Contact from '@/views/Contact.vue'
import TradingPage from '@/views/TradingPage.vue'
import Dashboard from '@/views/Dashboard.vue'
import Privacy from '@/views/Privacy.vue'
import BankView from '@/views/BankView.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/en', component: Home },
  { path: '/a-propos', component: About },
  { path: '/en/a-propos', component: About },
  { path: '/en/about', component: About },
  { path: '/services', component: Services },
  { path: '/en/services', component: Services },
  { path: '/faq', component: Faq },
  { path: '/en/faq', component: Faq },
  { path: '/contact', component: Contact },
  { path: '/en/contact', component: Contact },
  { path: '/taux-de-change', component: TradingPage },
  { path: '/en/taux-de-change', component: TradingPage },
  { path: '/en/exchange-rates', component: TradingPage },
  { path: '/dashboard', component: Dashboard },
  { path: '/en/dashboard', component: Dashboard },
  { path: '/privacy-policy', component: Privacy },
  { path: '/en/privacy-policy', component: Privacy },
  { path: '/bank-view', component: BankView }
  ,{ path: '/en/bank-view', component: BankView }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
